import { Input } from "@/components";

import SettingsTab from "../Tab";

const renderContent = ({ model, changeFormState, FormControl }) => (
    <div>
        <div className="row">
            <div className="col">
                Geotransform settings allow you to geotransform the lights to
                allow geolocation to work. This step should be completed after
                commissioning has taken place.
            </div>
        </div>
        <div className="row">
            <FormControl className="col-sm-3" name="x1">
                <Input
                    value={model.x1}
                    label="GT X1"
                    onChange={(value) =>
                        changeFormState({
                            x1: value,
                        })
                    }
                    type="number"
                />
            </FormControl>
            <FormControl className="col-sm-3" name="y1">
                <Input
                    value={model.y1}
                    label="GT Y1"
                    onChange={(value) =>
                        changeFormState({
                            y1: value,
                        })
                    }
                    type="number"
                />
            </FormControl>
            <FormControl className="col-sm-3" name="x2">
                <Input
                    value={model.x2}
                    label="GT X2"
                    onChange={(value) =>
                        changeFormState({
                            x2: value,
                        })
                    }
                    type="number"
                />
            </FormControl>
            <FormControl className="col-sm-3" name="y2">
                <Input
                    value={model.y2}
                    label="GT Y2"
                    onChange={(value) =>
                        changeFormState({
                            y2: value,
                        })
                    }
                    type="number"
                />
            </FormControl>
        </div>
        <div className="row">
            <FormControl className="col-sm-4" name="height">
                <Input
                    value={model.height}
                    label="GT Height"
                    onChange={(value) =>
                        changeFormState({
                            height: value,
                        })
                    }
                    type="number"
                />
            </FormControl>
            <FormControl className="col-sm-4" name="width">
                <Input
                    value={model.width}
                    label="GT Width"
                    onChange={(value) =>
                        changeFormState({
                            width: value,
                        })
                    }
                    type="number"
                />
            </FormControl>
            <FormControl className="col-sm-4" name="headingOffSet">
                <Input
                    value={model.headingOffSet}
                    label="GT Heading Offset"
                    onChange={(value) =>
                        changeFormState({
                            headingOffSet: value,
                        })
                    }
                    type="number"
                />
            </FormControl>
        </div>
    </div>
);

/**
 * Settings tab for configuring geo-transform reference points.
 *
 * @param props - The settings tab props including model and form state.
 * @returns The rendered geo-transform settings tab.
 */
const GeoTransformTab = (props) => (
    <SettingsTab {...props} renderContent={renderContent} />
);

export default GeoTransformTab;
